import { render, staticRenderFns } from "./HistoryManager.vue?vue&type=template&id=1948e1ce&"
import script from "./HistoryManager.vue?vue&type=script&lang=js&"
export * from "./HistoryManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports